import { FormAttribute } from '@/shared/forms/form-attribute.decorator'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'

export class HomeForm {
  @FormAttribute()
  public offers!: OfferLite[]

  @FormAttribute()
  public organisations!: OrganisationLite[]
}
